import React from 'react';
import { useParams } from 'react-router-dom';
import AddProductForm from '../components/admin/AddProductForm';

const EditProductPage = () => {
  const { id } = useParams();

  return (
    <AddProductForm
      mode="edit"
      productId={id}
    />
  );
};

export default EditProductPage;